export const accountPropertiesQueryKeys = {
    all: ['account-properties'] as const,
    byTagId: ({ tagId }: { tagId?: string | undefined } = {}) => [
        ...accountPropertiesQueryKeys.all,
        tagId,
    ],
    filters: ({ tagId, dates }: { tagId?: string | undefined; dates?: any } = {}) => [
        ...accountPropertiesQueryKeys.byTagId({ tagId }),
        dates,
    ],
};

export const salesMetricsQueryKeys = {
    all: ['sales-metrics'] as const,
    byTagId: ({ tagId }: any = {}) => [...salesMetricsQueryKeys.all, tagId] as const,
    filters: ({ tagId, dates }: { tagId?: string | undefined; dates?: any } = {}) => [
        ...salesMetricsQueryKeys.byTagId({ tagId }),
        dates,
    ],
};
